import { FunctionComponent } from "react";

export const FeatureDenied: FunctionComponent = () => {
  return <></>;
};
